const successEvent = new CustomEvent('success', {
  detail: {
    message: 'identification is successful',
  }
});
export const rejectEvent = new CustomEvent('reject', {
  detail: {
    message: 'agreement was rejected',
  }
});

export default successEvent;